import React from 'react';
import { Block as BlockIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const AccessDenied = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <BlockIcon
        sx={{
          fontSize: 80,
          color: 'text.secondary',
          marginBottom: '20px',
        }}
      />
      <Typography
        variant="h5"
        sx={{
          color: 'text.primary',
          marginBottom: '10px',
          fontWeight: 600,
        }}
      >
        Доступ запрещен
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
          maxWidth: '400px',
        }}
      >
        У вас нет прав для просмотра этой страницы. Обратитесь к администратору
        для получения доступа.
      </Typography>
    </Box>
  );
};
